<template>
    <div :class="inputClass">
        <input
            ref="input"
            :value="value"
            :placeholder="placeholder"
            :autofocus="hasAutofocus"
            :required="isRequired"
            type="number"
            :disabled="isDisabled"
            @input="changeNumber($event)"
        />

        <div class="form-input-number__spins">
            <button tabindex="-1" type="button" @click="stepNumber(1)">
                +
            </button>

            <button tabindex="-1" type="button" @click="stepNumber(-1)">
                -
            </button>
        </div>
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],

        props: {
            value: { type: [String, Number], default: undefined },
            placeholder: { type: String, default: undefined },
        },

        computed: {
            inputClass() {
                return {
                    'form-input-number': true,
                    'form-input-number--is-invalid': this.isInvalid,
                    'form-input-number--is-disabled': this.isDisabled,
                }
            },
        },

        methods: {
            stepNumber(direction) {
                const value = this.$refs.input.value || 0
                this.changeNumber(parseInt(value) + direction)
            },

            changeNumber(value) {
                value = value instanceof Event ? value.target.value : value
                this.change(parseInt(value))
            },
        },
    }
</script>
